import Enum from '@rover/types/src/Enum';

export class WizardPageType extends Enum<string> {
  static DEFAULT = new WizardPageType('default');

  static INLINE = new WizardPageType('inline');

  static MODAL = new WizardPageType('modal');
}
